import { ChangeDetectionStrategy, Component, computed } from '@angular/core'

import { CmpCta } from 'app/core/cms/generated/api-types'
import { ButtonComponent } from 'app/shared/button/button.component'
import { CmsLinkDirective } from 'app/shared/cms-link/cms-link.directive'
import { SvgComponent } from 'app/shared/svg/svg.component'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-cmp-cta',
  templateUrl: './cmp-cta.component.html',
  styleUrls: ['./cmp-cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, SvgComponent, CmsLinkDirective],
  providers: [{ provide: CmsBlock, useExisting: CmpCtaComponent }],
})
export class CmpCtaComponent extends CmsBlock<CmpCta> {
  readonly __typename = 'CmpCta'
  readonly targetTitle = computed(() => this.data().target?.internal?.value?.title ?? null)
}
